import { fbt } from 'fbtee'
import type { EventReportCategory } from '../types'

export function eventReportCategoryLabel(category: EventReportCategory): string {
  switch (category) {
    case 'venue':
      return fbt('Venue', 'Event report category: the event moved or lists the wrong venue')
    case 'datetime':
      return fbt('Date or time', 'Event report category: the date or start time is wrong, or it was postponed')
    case 'cancelled':
      return fbt('Cancelled', 'Event report category: the event was cancelled')
    case 'tickets':
      return fbt('Tickets link', 'Event report category: the ticket link is broken or wrong')
    case 'lineup':
      return fbt('Lineup', 'Event report category: artists are missing or wrong')
    case 'image':
      return fbt('Event image', "Event report category: the event's cover image is wrong")
    case 'duplicate':
      return fbt('Duplicate', 'Event report category: the event is listed twice')
    case 'spam':
      return fbt('Not a real event', 'Event report category: spam, a scam, or not a music event')
    case 'other':
      return fbt('Something else', 'Set report category: free-text fallback')
  }
}
